import {
    NavController,
    ViewController,
    LoadingController,
} from "ionic-angular";
import { Component, HostListener, Input, OnInit } from "@angular/core";
import { UserProvider } from "../../providers/user";
import { MenuProvider } from "../../providers/menu";
import { MenuDirective } from "../../directives/menu/menu";
import { NotificationsProvider } from "../../providers/notifications";
import { GlobalProvider } from "../../providers/global";

@Component({
    selector: "headerbar",
    templateUrl: "headerbar.html",
    viewProviders: [MenuDirective],
})
export class HeaderbarComponent {
    @Input() current: string;
    @Input() logo: boolean = true;

    private _resizeTimer: any = false;

    public userData: any;
    public isMobile: boolean;
    public userMenuOpen: boolean = false;
    public pages: Array<any>;
    public contactPages: Array<any>;
    public userPages: Array<any>;
    public unread: number;

    firebasePlugin;

    constructor(
        public viewController: ViewController,
        public navCtrl: NavController,
        public user: UserProvider,
        public menuLinks: MenuProvider,
        public loadingCtrl: LoadingController,
        public notifications_m: NotificationsProvider,
        public global: GlobalProvider
    ) {
        this.firebasePlugin = (<any>window).FirebasePlugin;
        // Seta versão do app (mobile/desktop)
        this.isMobile = window.innerWidth < 960;
        // Seta Páginas
        this.menuLinks.getPages(false).then((pages) => {
            this.pages = pages;
        });
        this.menuLinks.getContactPages().then((pages) => {
            this.contactPages = pages;
        });
        this.menuLinks.getUserPages().then((pages) => {
            this.userPages = pages;
        });
        // Pega Nome do usuário
        this.user.get().then((data: any) => {
            this.userData = data;
        });
        // Pegar as notificações não lidas
        this.global.unread$.subscribe((count) => {
            this.unread = count;
        });
        this.notifications_m.getUnreadCount().then((data: any) => {
            this.global.updateUnread(data.count);
        });
    }

    @HostListener("window:resize", ["$event"])
    onResize(event) {
        // Limpa o timer caso o usuário esteja resizeando freneticamente
        if (this._resizeTimer !== false) {
            clearTimeout(this._resizeTimer);
            this._resizeTimer = false;
        }
        // Seta timer para o resize:
        this._resizeTimer = setTimeout(() => {
            this.isMobile = event.target.innerWidth < 960;
        }, 200);
    }

    openPage(page: any = null) {
        if (page == null || !page.children) {
            // Caso página seja nula, vai para Home se possível
            if (page == null) {
                if (this.navCtrl.getActive().name != "HomePage") {
                    this.navCtrl.setRoot(
                        "HomePage",
                        {},
                        { animate: true, direction: "back" }
                    );
                }
                return;
            }
            // Caso seja a própria página
            if (page.component == this.current) {
                this.closeMenu();
                return false;
            }
            // Caso o usuário esteje deslogando
            if (page.component == null) {
                this.logout();
            } else {
                // Caso contrário apenas segue para a página
                //this.navCtrl.setRoot(page.component, {}, { animate: true, direction: 'forward' });
                this.navCtrl.push(
                    page.component,
                    {},
                    { animate: true, direction: "forward" }
                );
            }
        }
    }

    openNotifications() {
        this.navCtrl.push(
            "NotificacoesPage",
            {},
            { animate: true, direction: "forward" }
        );
    }

    logout() {
        this.user.logout();
    }

    public userClick() {
        if (this.userData) {
            this.userMenuOpen = !this.userMenuOpen;
        } else {
            this.navCtrl.setRoot(
                "LoginPage",
                {},
                { animate: true, direction: "back" }
            );
        }
    }

    public closeMenu() {
        this.userMenuOpen = false;
    }
}



// WEBPACK FOOTER //
// ./src/components/headerbar/headerbar.ts